import SettingsSection from '../../SettingsSection';

import { TextIconColor } from '~/components/core';
import { Markdown } from '~/components/Markdown';
import { useMarkdownFile } from '~/hooks';

const UserGroupsReference = () => {
  const { markdown: userGroupsOverview } = useMarkdownFile(
    '/docs/UserGroups/UserGroupsOverview.md'
  );

  const { markdown: userGroupsIntegrationAccess } = useMarkdownFile(
    '/docs/UserGroups/UserGroupsIntegrationAccess.md'
  );

  const { markdown: userGroupsModelAndProviderAccess } = useMarkdownFile(
    '/docs/UserGroups/UserGroupsModelAndProviderAccess.md'
  );

  const { markdown: userGroupsDlpConfig } = useMarkdownFile(
    '/docs/UserGroups/UserGroupsDlpConfig.md'
  );

  const markdowns = [
    userGroupsOverview,
    userGroupsIntegrationAccess,
    userGroupsModelAndProviderAccess,
    userGroupsDlpConfig
  ];

  return (
    <div className="py-4" data-testid="user-groups-reference-container">
      <SettingsSection title="User Groups Reference">
        {markdowns.map((markdown, index) => (
          <div
            className="bg-blue-chat-background my-3 flex w-full flex-col gap-2 rounded-md p-7"
            data-testid={`user-groups-reference-section-${index}`}
            key={index}
          >
            <Markdown styleDocsComponents textColor={TextIconColor.SECONDARY}>
              {markdown}
            </Markdown>
          </div>
        ))}
      </SettingsSection>
    </div>
  );
};

export default UserGroupsReference;
